import { CSSProperties } from "react";

const linkStyle: CSSProperties = {
  cursor: "pointer",

  display: "flex",
  alignItems: "center",

  whiteSpace: "nowrap",

  fontSize: "var(--font-size-navbar-item)",
  overflow: "hidden",
  userSelect: "none",

  textWrap: "nowrap",
  height: "3rem",
};

export default linkStyle;
